export function daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
}

export function onlyNumbers (value) {
    let onlyNumbers = ""
    let numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    [...value].forEach(element => {
        if (numbers.includes(element))
        onlyNumbers += element
    })
    
    return onlyNumbers
}